import apiClient from '../../../shared/api/apiClient'
import { ENDPOINTS } from '../../../shared/api/endpoints'

export interface RegisterDeviceTokenDto {
  fcmToken: string
  deviceType: 'WEB'
}

export interface DeviceTokenResponseDto {
  id?: string
  userId?: string
  fcmToken?: string
  deviceType?: 'WEB'
  isActive?: boolean
  createdAt?: string
  updatedAt?: string
  [key: string]: unknown
}

export const registerDeviceTokenApi = async (
  payload: RegisterDeviceTokenDto
): Promise<DeviceTokenResponseDto> => {
  const response = await apiClient.post<DeviceTokenResponseDto>(
    ENDPOINTS.DEVICE_TOKENS.REGISTER,
    payload
  )
  return response.data
}
